import React from 'react';
import { Link } from 'react-router-dom';
import './CartFooter.scss';

const CartFooter = props => {
    const { checkOutHandler, checkoutLoader, checkoutCTA, isframeProduct } = props;
    return (
        <div className="cart-footer col" aria-label="cart footer container">
            {/* <Link to="/checkout/onepage/" className="cart-footer_green" onClick={() => { checkOutHandler(true); }}>PROCEED TO CHECKOUT <i className="icon-chkout-arw"></i></Link> */}
            {/* <a className="cart-footer_green" href="https://www.lenskart.com/checkout/onepage/" onClick={() => { checkOutHandler(true); }}>PROCEED TO CHECKOUT <i className="icon-chkout-arw"></i>
            </a> */}
            {!checkoutLoader && <Link aria-label="proceed to checkout" className="button-green" to="/checkout/onepage/" onClick={() => { checkOutHandler(true); _gaq.push(['_trackEvent', 'Place Order', 'Cod'], ['ninja._trackEvent', 'Place Order', 'Cod']); }}>
                <span>{checkoutCTA && checkoutCTA.mainText ? checkoutCTA.mainText : 'PROCEED TO CHECKOUT'}</span>
                <i className="icon-chkout-arw"></i>
                {isframeProduct && checkoutCTA && checkoutCTA.subText && <span className="sub-text">{checkoutCTA.subText}</span>}
            </Link>}
            {
                checkoutLoader && <div className="loaderLK proceed-checkout-loader" aria-label="cart is loading">
                    <div className="barLK"></div>
                    <div className="barLK"></div>
                    <div className="barLK"></div>
                </div>
            }
        </div >
    );
};

export default CartFooter;
